const styles = {
  container: {
    pb: 0,
  },
  card: {
    p: 4,
    height: 150,
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    justifyContent: 'center',
  },
  img: {
    maxWidth: '100%',
    maxHeight: 50,
    objectFit: 'contain',
  },
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    flexWrap: 'nowrap',
    minHeight: 0,
  },
  contentItem: {
    width: '100%',
  },
  fillItem: {
    boxSizing: 'border-box',
    flex: 1,
    minHeight: 0,
    pb: 2,
    width: '100%',
  },
  scrollItem: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
    width: '100%',
  },
  scrollContent: {
    pb: 2,
  },
  dataGrid: {
    flex: 1,
    '& .MuiDataGrid-main': {
      minHeight: 0,
    },
  },
};

export default styles;
